import { IFacilityUser } from '../../models/auth';
import { IPaginatedResponse } from '../../services/api_service';
import {
    USERS_ADDING,
    USERS_CANCEL_OPERATION, USERS_EDITING, USERS_LOADING, USERS_LOAD_FAILED, USERS_LOAD_SUCCESS, USERS_REMOVE, USERS_REMOVE_FAILED, USERS_REMOVE_SUCCESS, USERS_REMOVING, USERS_SAVE_FAILED, USERS_SAVE_SUCCESS
} from '../actions/users';

export interface IUsersState {
  loading: boolean;
  users?: IPaginatedResponse<IFacilityUser>;
  error?: any;
  editingUser: IFacilityUser;
  editingUserError: any;
  removingUser: IFacilityUser;
  removingUserError: any;
  removingUserProcessing: boolean;
  addingUser: boolean;
}
const initialState: IUsersState = {
  loading: false,
  users: null,
  error: null,
  editingUser: null,
  editingUserError: null,
  removingUser: null,
  removingUserError: null,
  removingUserProcessing: false,
  addingUser: false
};

export default function (
  state: IUsersState = initialState,
  action
): IUsersState {
  switch (action.type) {
    case USERS_LOADING:
      return {
        ...state,
        loading: true,
        users: null,
        error: null
      };

    case USERS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.users,
        error: null
      };

    case USERS_LOAD_FAILED:
      return {
        ...state,
        loading: false,
        users: null,
        error: action.error
      };

    case USERS_EDITING:
      return {
        ...state,
        editingUser: action.user
      };

    case USERS_ADDING:
      return {
        ...state,
        addingUser: true
      };

    case USERS_SAVE_SUCCESS:
      return {
        ...state,
        editingUser: null,
        editingUserError: null,
        addingUser: false
      };

    case USERS_SAVE_FAILED:
      return {
        ...state,
        editingUserError: action.error
      };

    case USERS_REMOVE:
      return {
        ...state,
        removingUser: action.user
      };

    case USERS_REMOVING:
      return {
        ...state,
        removingUserProcessing: true
      };

    case USERS_REMOVE_SUCCESS:
      return {
        ...state,
        removingUser: null,
        removingUserError: null,
        removingUserProcessing: false,
        addingUser: false
      };

    case USERS_REMOVE_FAILED:
      return {
        ...state,
        removingUserError: action.error,
        removingUserProcessing: false
      };

    case USERS_CANCEL_OPERATION:
      return {
        ...state,
        editingUser: null,
        editingUserError: null,
        removingUser: null,
        removingUserError: null,
        removingUserProcessing: false,
        addingUser: false
      };
  }

  return state;
}
